// extracted by mini-css-extract-plugin
export var label = "_iy-0";
export var treatmentCard = "_iy-1";